import ContentbuyerPurchasedVideoTable from "../../../../components/ContentbuyerPurchasedVideoTable/ContentbuyerPurchasedVideoTable";
import ModaltableHeader from "../../../../components/ModaltableHeader/ModaltableHeader";
import UserWrapper from "../../../../layout/userwrapper/UserWrapper";
import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import styles from "../../../../styles/pages/user/content-buyer-purchasevideo.module.scss";
import Pagination from "../../../../components/UtilitiesComponent/Pagination";
import useFetch from "../../../../hooks/api/useFetch";

const PurchaseVideos = () => {
  const { data, isSuccess, isLoading } = useFetch(
    ["purchased-videos"],
    `buyer/videos?purchased=yes`
  );
  console.warn(data);
  return (
    <UserWrapper headerPurchaseBtn={true} footerChatBtn={false}>
      <Paper
        elevation={0}
        className={`pageInnerWrapper ${styles.pagePurchaseVdo}`}
      >
        <Box className={styles.tableTopHeader}>
          <ModaltableHeader
            allVideo={true}
            searchType={false}
            pendingBtn={false}
            filterBtn={false}
          />
        </Box>
        <Box className={styles.contentPageTable}>
          <ContentbuyerPurchasedVideoTable videoList={data?.data?.data} />
        </Box>
        <Box className={styles.innerPagination}>
          <Pagination
            lastpage={undefined}
            onClick={undefined}
            sendDataToParent={undefined}
          />
        </Box>

        {/* =========================================== */}
        {/* ============= END ALERT START ============= */}
        {/* =========================================== */}

        {/* <Box className={styles.tableMsg}>
                        <Typography variant='body2'>End of list. We couldn't find more videos within the specified date range.</Typography>
                    </Box> */}

        {/* =========================================== */}
        {/* ============== END ALERT END ============== */}
        {/* =========================================== */}
      </Paper>
    </UserWrapper>
  );
};

export default PurchaseVideos;
